import React from "react";
import { dimoi as dimoiUnfilt } from "../Dimoi";
import { XCircleIcon } from "@heroicons/react/solid";
import {
  MultiSelect,
  MultiSelectItem,
  Icon,
  List,
  ListItem,
} from "@tremor/react";
import { removeDiacriticsAndCapitalize } from "../../../utils/checkMisthosi";

const ChooseDimo = ({ setDimoiSelected, dimoiSelected }) => {
  const dimoi = dimoiUnfilt
    .map((dim) => removeDiacriticsAndCapitalize(dim))
    .sort();
  const handleDeleteListItem = (e) => {
    const value =
      e.target.parentNode.parentNode.parentNode.firstChild.textContent;

    const newDOYSelected = dimoiSelected.filter((dim) => dim !== value);
    setDimoiSelected(newDOYSelected);
  };

  return (
    <div className="form-group">
      <label htmlFor="dimos">Δημαρχεία/Ληξιαρχεία:</label>
      <MultiSelect
        placeholder="Επιλέξτε Δημαρχείο"
        onValueChange={setDimoiSelected}
        value={dimoiSelected}
      >
        {dimoi.map((dim, i) => {
          return (
            <MultiSelectItem key={`${i}-${dim}`} value={dim}>
              {dim}
            </MultiSelectItem>
          );
        })}
      </MultiSelect>
      <List>
        {dimoiSelected?.map((dim, i) => {
          return (
            <ListItem className="dimoi-list" key={`${i}-${dim}`}>
              <span>{dim}</span>
              <span>
                <Icon
                  onClick={handleDeleteListItem}
                  className={"cursor-pointer"}
                  icon={XCircleIcon}
                  size={"sm"}
                  color="red"
                  tooltip="Διαγραφή"
                ></Icon>
              </span>
              <ListItem />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default ChooseDimo;
